import React from 'react'
import Avatar from '@material-ui/core/Avatar'
import Box from '@material-ui/core/Box'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { LocationCard } from 'components/program-marketing/location-card'
import { urls } from 'pages/junior-league-marketing/layout/menus'

const useStyles = makeStyles(() => ({
  avatar: {
    width: '128px',
    height: '128px',
  },
  phone: {
    textDecorationLine: 'underline',
    fontWeight: 'bold',
    fontFamily: 'PlusJakarta Text',
  },
}))

export const Coach = ({ coach, viewContactCoach }) => {
  const classes = useStyles()
  const searchUrl = `${urls.search}?${new URLSearchParams({
    radius: 'any',
    type: 'coach',
    query: coach.name,
  })}`

  return (
    <LocationCard
      title="Your Coach"
      buttonText="Contact Coach"
      secondButtonText={`More Programs By ${coach.name}`}
      secondUrl={searchUrl}
      onClick={viewContactCoach}
    >
      <Box align="center">
        <Box my={3}>
          <Avatar
            className={classes.avatar}
            src={coach.profilePhoto}
            alt={coach.name}
          />
        </Box>
        <Box mb={1}>
          <Typography variant="h5">{coach.name}</Typography>
        </Box>
        <Box mb={1}>
          <Link href={`tel:${coach.phone}`}>
            <Typography
              align="center"
              variant="h6"
              color="textSecondary"
              className={classes.phone}
            >
              {coach.phone}
            </Typography>
          </Link>
        </Box>
      </Box>
    </LocationCard>
  )
}
